import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Send } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_vets-intake-demo/artifacts/e4mtecfo_Untitled%20design%20%2892%29.png";
const NEWSLETTER_URL = "http://eepurl.com/jCnhRE";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white text-wv-blue border-t border-gray-200" data-testid="main-footer" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img 
                src={LOGO_URL} 
                alt="Worthy Vets Service Group" 
                className="h-20 w-auto"
              />
            </div>
            <p className="text-base text-gray-600 mb-6">
              Because Every Veteran is Worthy. We help veterans navigate the VA process with 
              compassion, expertise, and dedication to your success.
            </p>
          </div>

          {/* Newsletter Signup */}
          <div>
            <h4 className="font-heading text-xl font-bold mb-6 text-wv-red">Stay Connected</h4>
            <p className="text-base text-gray-600 mb-4">
              Subscribe to our newsletter for veteran resources, updates, and tips.
            </p>
            <a
              href={NEWSLETTER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-wv-red text-white px-5 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors"
              data-testid="footer-newsletter-signup"
            >
              <Send className="w-4 h-4" />
              Subscribe to Newsletter
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-xl font-bold mb-6 text-wv-red">Quick Links</h4>
            <nav className="space-y-4">
              <Link to="/" className="block text-lg text-gray-600 hover:text-wv-red transition-colors">
                Home
              </Link>
              <Link to="/about" className="block text-lg text-gray-600 hover:text-wv-red transition-colors">
                About Us
              </Link>
              <Link to="/services" className="block text-lg text-gray-600 hover:text-wv-red transition-colors">
                Services
              </Link>
              <Link to="/intake" className="block text-lg text-gray-600 hover:text-wv-red transition-colors">
                Get Started
              </Link>
              <Link to="/donate" className="block text-lg text-wv-red hover:text-red-700 transition-colors font-semibold">
                Support a Veteran
              </Link>
              <Link to="/contact" className="block text-lg text-gray-600 hover:text-wv-red transition-colors">
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-xl font-bold mb-6 text-wv-red">Contact Us</h4>
            <div className="space-y-4">
              <a 
                href="mailto:info@worthyvetsservicegroup.com" 
                className="flex items-center gap-3 text-base text-gray-600 hover:text-wv-red transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5 text-wv-red flex-shrink-0" />
                <span>info@worthyvetsservicegroup.com</span>
              </a>
              <a 
                href="tel:+15716006706" 
                className="flex items-center gap-3 text-lg text-gray-600 hover:text-wv-red transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5 text-wv-red flex-shrink-0" />
                <span>(571) 600-6706</span>
              </a>
              <div className="flex items-start gap-3 text-base text-gray-600">
                <MapPin className="w-5 h-5 text-wv-red flex-shrink-0 mt-1" />
                <span>23710 Schooler Plaza Suite 275<br />Brambleton, VA 20148</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-base">
              &copy; {currentYear} Worthy Vets Service Group. All rights reserved.
            </p>
            <p className="text-gray-500 text-base text-center md:text-right">
              This is not legal or medical advice. We provide guidance and support for the VA claims process.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
